export default "__VITE_ASSET__DYx$EPuM__"